import ProductSalesLeaderboard from './ProductSalesLeaderboard';
export default ProductSalesLeaderboard;